export const EXPIRY_OPTIONS = [
  { value: '604800', label: '7 days' }, // 7 * 24 * 60 * 60
  { value: '2592000', label: '30 days' }, // 30 * 24 * 60 * 60
  { value: '5184000', label: '60 days' }, // 60 * 24 * 60 * 60
  { value: '7776000', label: '90 days' }, // 90 * 24 * 60 * 60
  { value: '31536000', label: '1 year' }, // 365 * 24 * 60 * 60
] as const

export const DEFAULT_EXPIRY_SECONDS = EXPIRY_OPTIONS[1].value // 30 days

export function getExpirationDate(seconds: string): Date {
  const now = new Date()

  return new Date(now.getTime() + parseInt(seconds, 10) * 1000)
}

export function formatExpiryLabel(option: {
  value: string
  label: string
}): string {
  const expirationDate = getExpirationDate(option.value)
  const formatted = expirationDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  return `${option.label} (${formatted})`
}
